import * as React from "react"
import {fontFaceBarlow} from './shared.module.scss'
import { getImage,GatsbyImage } from 'gatsby-plugin-image'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBed,faBath,faStar,faTag } from '@fortawesome/free-solid-svg-icons'
import { getYardiPropId } from '../utils/propertyMapUtil';
import { searchListingContainer } from './searchNotMap.module.scss'
import {utinc} from './tiny_components/priceDisplay.module.scss'
import { getRentDisplay } from '../utils/helperFunctions';
import { Link } from "gatsby"

const SearchNotMap = ({filterBeds,filterBaths,filterPrice,filterAv,viewing,communityDeals,priceRange,setHoveringOver,proformaRange})=>{

    return(

                    <div className="column " id="notMap">
                        <div className="columns" id="filters">
                            <div className="column" style={{padding:'2px'}}>
                                <div className="select" style={{width:'100%'}}>
                                    <select onChange={filterBeds} style={{width:'100%'}}>
                                    <option value="">
                                        # of bedroom
                                    </option>
                                    <option value="0">Studio</option>
                                    <option value="1">1</option>
                                    <option value="2">2</option>
                                    <option value="3">3</option>
                                    <option value="4">4</option>
                                </select>
                                </div>
                            </div>
                            <div className="column" style={{padding:'2px'}}>
                                <div className="select" style={{width:'100%'}}>
                                <select onChange={filterBaths} style={{width:'100%'}}>
                                    <option value="">
                                        # of bathroom
                                    </option>
                                    <option value="1">1</option>
                                    <option value="2">2</option>
                                    <option value="3">3</option>
                                </select>
                                </div>
                            </div>
                            <div className="column" style={{padding:'2px'}}>
                                <div className="select" style={{width:'100%'}}>
                                <select onChange={filterPrice} style={{width:'100%'}}>
                                    <option value="">
                                        Max Rent
                                    </option>
                                    <option value="1000">$1,000</option>
                                    <option value="1500">$1,500</option>
                                    <option value="2000">$2,000</option>
                                    <option value="2500">$2,500</option>
                                    <option value="3000">$3,000</option>
                                    <option value="3500">$3,500</option>
                                    <option value="4000">$4,000</option>
                                </select>
                                </div>
                            </div>
                            <div className="column" style={{padding:'2px'}}>
                                <div className="select" style={{width:'100%'}}>
                                    <select style={{width:'100%'}} onChange={filterAv}>
                                    <option value="">
                                        Availability
                                    </option>
                                    <option value="now">Available Now</option>
                                    <option value="soon">Available Soon</option>
                                    <option value="all">Show All</option>
                                </select>
                                </div>
                            </div>
                        </div>
                        <br />
                        <div className={searchListingContainer}>
                        {viewing.map((n,i)=>{
                            let baths = n.maxBaths ? n.maxBaths : n.maxBathsDec;
                            let minBeds = n.minBeds && n.minBeds > 1 ? n.minBeds : 1;
                            let maxBeds = n.maxBeds;

                            return    <div key={i}>
                                <div className="columns" 
                                    onMouseEnter={()=>{setHoveringOver(n.communityName)}}
                                    onMouseLeave={()=>{setHoveringOver('')}}
                                >
                                    <div className="column">
                                        <div className="deal-image-overlay-container">
                                            <Link to={`/apartments/${n.area.toLowerCase()}/${n.citySlug.toLowerCase()}/${n.slug.toLowerCase()}/`}>
                                        <GatsbyImage image={n.hero && n.hero.gatsbyImageData ? getImage(n.hero.gatsbyImageData) : ''} 
                                        alt="Community Image" style={{maxHeight:'190px',borderRadius:'15px'}}/>
                                                {communityDeals && getYardiPropId(n.rmpropid) in communityDeals && 
                                                <div className="deal-overlay-text">Move-In Deal!!</div>
                                                }
                                            </Link>
                                        </div>
                                    </div>
                                    <div className={fontFaceBarlow+" column"}>
                                        <h3 className={fontFaceBarlow+" is-size-4"}><Link to={`/apartments/${n.area.toLowerCase()}/${n.citySlug.toLowerCase()}/${n.slug.toLowerCase()}/`}>{n.communityName}</Link></h3>
                                        <p dangerouslySetInnerHTML={{ __html: n.address.replace(',', '<br>') }} />
                                        <p><a href={`tel:${n.phone.replace(/\D/g, '')}`}>{n.phone}</a></p> 
                                        <div className="columns is-mobile">
                                            <div className="column">
                                                <p><FontAwesomeIcon icon={faBed} size="sm" />{" "}
                                                        {minBeds === maxBeds
                                                            ? `${minBeds} bedroom`
                                                            : `${minBeds} - ${maxBeds} bedroom`}</p>
                                                <p><FontAwesomeIcon icon={faBath}  size="sm"/>&nbsp; {baths > 1 ? `1 - ${baths}` : baths} bathroom</p>
                                                <p>
                                                    <FontAwesomeIcon icon={faTag}  size="sm"/>&nbsp; 
                                                {getRentDisplay(n, priceRange, proformaRange, getYardiPropId)}
                                                {n.utilitiesIncluded ? <span className={utinc}>*Utilities Included</span>:''}
                                                </p>
                                                {n.specialPopup && <p><FontAwesomeIcon icon={faStar}  size="sm"/>{n.specialPopup.specialTitle}</p>}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <hr />
                            </div>
                        })}
                    </div>
                </div>

    )
}

export default SearchNotMap
